const hero = {
    accentBackground: '#ea7200',
    title: {
        copy: 'Lorem Ipsum Dolor Sit Amet',
        color: '#fffefe',
    },
    backgroundColor: '',
    backgroundImage: '/images/homepage-hero.jpg',
    video: '/videos/pd__hero--black-and-white.mp4',
};

export default hero;



// WEBPACK FOOTER //
// ./app/config/context/homepage/hero.js